// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66566ef9","239":"df4925d1","557":"1f34c833","732":"0de0c044","762":"5c284130"}[chunkId] + ".chunk.js";
};